import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { usePageLink } from '../../hooks/usePageLink'
import { useLanguage } from '../../context/LanguageContext'
import {
  hasTrackingConsent,
  loadTrackers,
  saveTrackingConsent,
  trackPageView,
} from '../../utils/tracking'

const COPY = {
  EL: {
    message:
      'Ο ιστότοπός μας χρησιμοποιεί cookies για να διασφαλίσει την καλύτερη δυνατή εμπειρία και να συλλέγει δεδομένα χρήσης. Συμφωνείτε;',
    accept: 'Αποδοχή',
  },
  EN: {
    message:
      'Our website uses cookies to ensure the best possible experience and to collect usage data. Do you agree?',
    accept: 'Accept',
  },
}

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)
  const { lang } = useLanguage()
  const copy = COPY[lang] || COPY.EL
  // Localized cookie policy page; its title doubles as the link text.
  const cookiesPolicyPage = usePageLink('cookies-policy')

  useEffect(() => {
    setVisible(!hasTrackingConsent())
  }, [])

  const handleAccept = () => {
    saveTrackingConsent()
    loadTrackers()
    trackPageView() // count the page the visitor accepted on
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="region"
      aria-label="Cookies"
      className="fixed bottom-0 w-full bg-[#222] text-white p-4 z-50 text-center"
    >
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <div>
          <p className="text-white">{copy.message}</p>
          <Link
            to={cookiesPolicyPage.uri}
            className="text-sm underline text-gray-300 hover:text-white mt-1 block sm:inline sm:ml-2"
          >
            {cookiesPolicyPage.title}
          </Link>
        </div>
        <button
          onClick={handleAccept}
          className="btn-outline-light px-4 py-1 font-semibold text-sm md:text-base inline-flex items-center"
        >
          {copy.accept}
        </button>
      </div>
    </div>
  )
}

export default CookieBanner
